import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import RenderCategoryDetails from '../../_common/renderCategoryDetails.mdx';
import KlarnaPaymentPayload from '../../_common/klarnaPaymentPayload.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A promise that resolves to an instance of `}<inlineCode parentName="p">{`IKlarnaPaymentMethodManager`}</inlineCode>{` or `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    <Group summary='IKlarnaPaymentMethodManager' mdxType="Group">
	<Item title='start' subtitle='(paymentPayload: KlarnaPaymentPayload) => Promise<void>' mdxType="Item">
		This function starts the payment process. It should be called with the selected payment method category id, when the
		user has selected and confirmed the desired payment category. The payment method category id which needs to be sent
		to the start function can be retrieved from the onPaymentMethodCategoriesChange function
		<Group mdxType="Group">
			<Item title='paymentPayload' subtitle='{ paymentMethodCategoryId: string }' mdxType="Item">
				<Group summary='Properties' mdxType="Group">
					<KlarnaPaymentPayload mdxType="KlarnaPaymentPayload" />
				</Group>
			</Item>
		</Group>
	</Item>
	<Item title='renderCategory' subtitle='(details: RenderCategoryDetails) => Promise<void>' mdxType="Item">
		This function is used so that Klarna can render the selected payment category details (paymentMethodCategoryId) in a
		DOM element (containerId). It uses a callback (onHeightChange) to inform when the height of the contianer has
		changed.
		<Group mdxType="Group">
			<Item title='details' subtitle='{ containerId: string, paymentMethodCategoryId: string, onHeightChange:(newHeight:number)=> void }' mdxType="Item">
				<Group summary='Properties' mdxType="Group">
					<RenderCategoryDetails mdxType="RenderCategoryDetails" />
				</Group>
			</Item>
		</Group>
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      